import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

import './PageNotFound.css';

export default function PageNotFound() {
    const location = useLocation();

    return (
        <section
            id="page-not-found"
            className="min-vh-100 d-flex align-items-center py-5"
            aria-labelledby="page-not-found-heading"
        >
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12} md={9} lg={7} className="text-center">
                        <div className="page-not-found-card p-4 p-md-5 rounded-4 shadow-sm">
                            <div className="page-not-found-badge mb-3">404</div>
                            <h1
                                id="page-not-found-heading"
                                className="display-5 fw-bold mb-3"
                            >
                                Oops!
                            </h1>
                            <p className="lead text-muted mb-4">
                                We couldn&#39;t find what you were looking for.
                                It may have moved, or the URL might be
                                incorrect.
                            </p>
                            <p className="small text-muted mb-4">
                                Requested path: <code>{location.pathname}</code>
                            </p>
                            <div className="d-grid gap-3 d-sm-flex justify-content-center">
                                <Button
                                    as={Link}
                                    to="/"
                                    variant="primary"
                                    size="lg"
                                    className="px-4"
                                >
                                    Go to homepage
                                </Button>
                                <Button
                                    as={Link}
                                    to="/communities"
                                    variant="outline-secondary"
                                    size="lg"
                                    className="px-4"
                                >
                                    Browse communities
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
